import { useCallback } from "react";
import { useRecoilValue } from "recoil";

import { deviceCommsStateAtom } from "../atoms/devices";
import { getDevicePresence } from "./DevicePresence";
import { getDeviceOfflineState } from "./DeviceOfflineState";
import { safeJsonParse } from "./Json";

//One way in for every screen that shows whether a device is online, so the definition of offline
//lives in one place rather than in a copy per table and card.
//
//Returns a function rather than a value, because tables call it once per row and a hook per row
//is not allowed.
export const useDeviceOfflineState = () => {
	const commsState = useRecoilValue(deviceCommsStateAtom);

	return useCallback(
		(device) => {
			//Some screens hand over a pre-parsed reportedState (devicesStateSelector does this),
			//others the raw reported_state string from the API. safeJsonParse passes an object
			//straight through, where JSON.parse would throw on it.
			const reportedState = device?.reportedState ?? safeJsonParse(device?.reported_state, {}, "reported_state");
			const presence = getDevicePresence({
				deviceId: device?.id,
				reportedState: reportedState ?? {},
				fallbackUpdatedAt: device?.updatedAt,
			});

			return {
				presence,
				...getDeviceOfflineState({ presence, commsEvent: commsState?.[device?.id] ?? null }),
			};
		},
		[commsState]
	);
};
